import * as React from "react"
import * as _ from "lodash"
import { IDoctor } from "@curefit/care-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import RenderConfidentialData from "../common/RenderConfidentialData"

export interface PatientMedicationHistoryContainerProps {
    doctor: IDoctor,
    consultationData: any,
    patientPersonalProfile: PatientPersonalProfile
}

export const aboutPatientHeadersToDisplay = [ "SURGERIES", "HABITS" ];
export const comorbidConditionsToDisplay = [ "SELF", "FATHER", "MOTHER", "BROTHER", "SISTER", "GRANDFATHER", "GRANDMOTHER" ];

const PatientMedicationHistoryContainer = (props: PatientMedicationHistoryContainerProps) => {
    let aboutPatientToDisplay: string[] = [];
    let surgeries = "";
    let doctorName = `${!_.isEmpty(props.doctor.prefix) ? props.doctor.prefix + " " : ""}${props.doctor.name}`;
    if (props.consultationData && props.consultationData.surgery && props.consultationData.surgery.surgeryList && props.consultationData.surgery.surgeryList.length > 0) {
        _.map(props.consultationData.surgery.surgeryList, (surgery) => {
            surgeries = surgeries.concat(`${surgery.surgeryName}, `)
        })
    }
    aboutPatientToDisplay.push(surgeries !== "" ? surgeries.trim().slice(0, -1) : "No data found");

    let habits = "";
    if (props.patientPersonalProfile && props.patientPersonalProfile.habits && props.patientPersonalProfile.habits.genericHabits && props.patientPersonalProfile.habits.genericHabits.length > 0) {
        _.map(props.patientPersonalProfile.habits.genericHabits, (habit) => {
            habits = habits.concat(`${habit.item}, `);
        });
    }

    let comorbidConditions = props.consultationData && props.consultationData.pastConditions ? props.consultationData.pastConditions : [];
    let formattedConditions: any = {};
    if (props.consultationData && props.consultationData.pastConditions && props.consultationData.pastConditions.length > 0) {
        _.map(comorbidConditionsToDisplay, (relationship) => {
            let conditions = comorbidConditions.filter(item => item.relationship === relationship);
            if (conditions.length > 0) formattedConditions[relationship] = conditions.map(item => item.displayValue).join(", ");
            else formattedConditions[relationship] = "No data found";
        })
    }
    aboutPatientToDisplay.push(habits !== "" ? habits.trim().slice(0, -1) : "No data found")
    return (
        <div className={"patient-medication-history-container patient-consultation-summary-container"}>
            <div className="doctor-details-container summary-subcontainer">
                <div className="doctor-label summary-subheader brandon-bold">DOCTOR</div>
                <div className="doctor-name-value-label">{doctorName}</div>
            </div>            
            <div className={"medication-history-details"}>
                <div className={"summary-label-header brandon-bold"}>Summary</div>
                <div className={"about-patient-container"}>
                    <div className={"header brandon-bold"}>ABOUT</div>
                    {
                        _.map(aboutPatientHeadersToDisplay, (item, index) => {
                            return (
                                <RenderConfidentialData>
                                    <div className={"about-patient-row"} key={`about-patient-row-${index}`}>
                                        <div className={"about-patient-key brandon-bold"}>{item}</div>
                                        <div className={"about-patient-value"}>{aboutPatientToDisplay[index]}</div>
                                    </div>
                                </RenderConfidentialData>
                            )
                        })
                    }
                </div>
                <div className={"patient-comorbid-conditions-container"}>
                    <div className={"header brandon-bold"}>COMORBID CONDITIONS</div>
                    {
                        _.map(comorbidConditionsToDisplay, (item, index) => {
                            return (
                                <RenderConfidentialData>
                                    <div className={"comorbid-patient-row"} key={`comorbid-patient-row-${index}`}>
                                        <div className={"comorbid-patient-key brandon-bold"}>{item}</div>
                                        <div className={"comorbid-patient-value"}>{formattedConditions[item]}</div>
                                    </div>
                                </RenderConfidentialData>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default PatientMedicationHistoryContainer;